import { render, staticRenderFns } from "./ItalicSubheader.vue?vue&type=template&id=2c8f015c&scoped=true&"
import script from "./ItalicSubheader.vue?vue&type=script&lang=js&"
export * from "./ItalicSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f015c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
